/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationLogoListModel } from '../../models/organization-logo-list-model';

export interface AdminFhirIdLogoGet$Params {
  fhirId: string;
}

export function adminFhirIdLogoGet(http: HttpClient, rootUrl: string, params: AdminFhirIdLogoGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationLogoListModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdLogoGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OrganizationLogoListModel>>;
    })
  );
}

adminFhirIdLogoGet.PATH = '/Admin/{fhirId}/Logo';
